module.exports = __webpack_public_path__ + "static/media/7_C@2x.0bf80e8e.png";